"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadMFE = exports.UseLoadMFEStatus = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const createLogger_1 = tslib_1.__importDefault(require("../logger/createLogger"));
var UseLoadMFEStatus;
(function (UseLoadMFEStatus) {
    UseLoadMFEStatus["Success"] = "success";
    UseLoadMFEStatus["Error"] = "error";
})(UseLoadMFEStatus = exports.UseLoadMFEStatus || (exports.UseLoadMFEStatus = {}));
const logger = (0, createLogger_1.default)();
const useLoadMFE = ({ importPath, }) => {
    return (0, react_1.useCallback)(async () => {
        try {
            const module = await System.import(importPath);
            return { mfe: module, status: UseLoadMFEStatus.Success };
        }
        catch (error) {
            logger.error(error);
            System.delete(System.resolve(importPath));
            return { status: UseLoadMFEStatus.Error, error };
        }
    }, [importPath]);
};
exports.useLoadMFE = useLoadMFE;
//# sourceMappingURL=useLoadMFE.js.map